// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-filter[data-v-28543e97]{cursor:pointer;position:relative}.toggle-filter>i[data-v-28543e97]{position:absolute;right:5px;top:5px}.collapsed>.when-opened[data-v-28543e97],:not(.collapsed)>.when-closed[data-v-28543e97]{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
